<template>
    <div></div>
</template>

<script>
export default {
    created() {
        this.$store
        .dispatch("logout")
        .then(() => {
            this.$router.push({name:'home'})
        })
        .catch(err => {
          console.log(err);
        });
    }
}
</script>

<style>

</style>
